import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaders, HttpClient} from '@angular/common/http';
import {ApiService} from './api.service';
import {Channel} from "../models/channel";
import {Pagination} from '@core/shared/models/pagination';
import {AllPaginateItemsAPI} from "@core/shared/models/all-paginate-items-api";

@Injectable({
    providedIn: 'root'
})
export class ChannelService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public getItemAPI(id: number, params?: string[]): Observable<Channel> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/channels/${id}`;

        if(!!params && params.length > 0){

            url = `${url}?${params}`;
        }

        return this._httpClient.get<Channel>(url,{
            headers: headers
        });
    }

    public getPaginationSocietyItemAPI(id: number, params?: string[]): Observable<Pagination<Channel>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${id}/channels`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<Channel>>(url, {
            headers: headers
        });
    }

    public getSocietyItemsAPI(id: number, params?: string[]): Observable<Channel[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${id}/channels`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Channel[]>(url, {
            headers: headers
        });
    }

    public getItemsAPI(params?: string[]): Observable<Channel[]> {

        return new AllPaginateItemsAPI<Channel>(this.getPaginationItemsAPI.bind(this), params).request$;
    }

    public getPaginationItemsAPI(params?: string[]): Observable<Pagination<Channel>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/channels`;

        params = params || [];

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<Channel>>(url, {
            headers: headers
        });
    }

    public createSocietyItemAPI(id: number, data: object): Observable<Channel> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<Channel>(`${this._apiService.getApiUrl(false, true)}/societies/${id}/channels`, data, {
            headers: headers
        });
    }

    public updateItemAPI(id: number, data: object): Observable<Channel> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.patch<Channel>(`${this._apiService.getApiUrl(false, true)}/channels/${id}`, data,{
            headers: headers
        });
    }

    public deleteItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.delete<void>(`${this._apiService.getApiUrl(false, true)}/channels/${id}`,{
            headers: headers
        });
    }

    public downloadTechnicalDocumentation(locale: string): Observable<Blob> {

        return this._httpClient.get(`${this._apiService.getApiUrl(false, true)}/channels/${locale}/technical/documentation`, {
            responseType: 'blob'
        });
    }
}
